import { t } from '@/i18n';
import { z } from 'zod';

export const modalFormSchema = z.object({
  title: z.string().min(1, t('pages.application_category_video.componnets.category_video_create_modal.schema.required')),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
